var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-center"},[_c('v-container',[_c('v-progress-circular',{attrs:{"width":_vm.width,"color":_vm.color,"indeterminate":"","size":_vm.size}}),(_vm.message)?_c('div',{staticClass:"pa-3 primary--text"},[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }